export const getThemeValue = (selectedTheme, themeColors) => {
    return themeColors[selectedTheme ?? 'light'];
};
// DEPRECATED: Leaving this to avoid breaking changes outside Skeletor
export const getThemeColor = (selectedTheme, themeColors) => getThemeValue(selectedTheme, themeColors);
